export enum BmStage {    
    Initializing = 0,
    FilteringOneWays = 1,
    Smelac = 2,
    CompilingResultsRazorView = 3,
    WritingResults = 4,
    RenderingResults = 5
}